import React from 'react'
import styles from '../ToolsDropdownToggleButton.module.css'

function ToolsDropDownToggleButton(props) {
    return (
        <div className="onlyVisibleOnBigScreens">
            <p onClick={props.toggleDropdown} id={styles.dropdownToggleButton}>Tools ▼</p>
        </div>
    )
}

export default ToolsDropDownToggleButton
